/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Refunded: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.5 6C11.5 5.44772 11.9477 5 12.5 5H15C17.7614 5 20 7.23858 20 10C20 12.7614 17.7614 15 15 15H7.41421L9.70711 17.2929C10.0976 17.6834 10.0976 18.3166 9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071L4.29289 14.7071C3.90237 14.3166 3.90237 13.6834 4.29289 13.2929L8.29289 9.29289C8.68342 8.90237 9.31658 8.90237 9.70711 9.29289C10.0976 9.68342 10.0976 10.3166 9.70711 10.7071L7.41421 13H15C16.6569 13 18 11.6569 18 10C18 8.34315 16.6569 7 15 7H12.5C11.9477 7 11.5 6.55228 11.5 6Z'
      fill='currentColor'
    />
  </React.Fragment>
)
